import { useState } from "react";
import PropTypes from "prop-types";

export const makeUrlClickable = (text) => {
  if (!text) return "";

  if (text.includes('<a')) {
    return text.replace(/href=['"]([^'"]+)['"]/g, (match, url) => {
      // Clean URL by removing URL-encoded HTML tags
      const cleanUrl = url.replace(/%3C\/?p%3E/g, '');
      return `href="${cleanUrl}"`;
    });
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text.replace(urlRegex, (url) => {
    const cleanUrl = url.replace(/%3C\/?p%3E/g, '');
    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`;
  });
};

export const RenderRichText = ({ text }) => {
  const [showMore, setShowMore] = useState(false);

  const displayedText = showMore
    ? makeUrlClickable(text)
    : makeUrlClickable(text?.slice(0, 1000));

  return (
    <div className="recall-details-body-item">
      <div
        className="recall-details-body-item-content"
        dangerouslySetInnerHTML={{
          __html: displayedText
        }}
      />
      {text?.length > 1000 && (
        <button className="show-more-button" onClick={() => setShowMore(!showMore)}>
          {showMore ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

RenderRichText.propTypes = {
  text: PropTypes.string
};
